import React from 'react';
import { Route, Link, withRouter } from 'react-router-dom';
import s from './Sidebar.scss';
import question from '../../../assets/images/icons/help-circle-cyan.svg';
import AgilisBlanco from '../../../assets/images/icons/Isologo_blanco - grande.svg';
import { connect } from 'react-redux';

const Links  = ({ list, next, urlLocation, path, closeModal, abtestData, mobile, uw  }) => {
    return(
        <ul>
        {Object.entries(list).sort((a, b) => a[1].span - b[1].span).map(([key,value]) => {
            let name = value.name_parser ? value.name_parser(abtestData, value.name) : value.name;
            return (
                <Route key={key} path={path + value.path}>
                    {({ match }) => (
                        <Link
                            aria-label={`Ir al formulario ${name}`}
                            onClick={closeModal}
                            to={(value.completed || value.status === next) ? `${urlLocation}${value.path}` : '#'}
                            className={`${match ? s.active : ''} ${value.completed ? s.completed : ''} ${ value.status === next ? s.next : ''} ${uw ? s.uw : ''}`}
                        >
                                <li>
                                    {(mobile) ? <p className={s.text}>{name}</p> : name }
                                </li>
                        </Link>
                    )}
                </Route>
        )})}
        </ul>
    );
}

class Sidebar extends React.Component {

    state = {
        lastScrollY: 0,
        fixSidebar: false,
    }

    render() {
        const { list, next, path, urlLocation, title, is_staff, children = null, hot, apptype, borrower, closeModal, auth, is_user, mobile, status, uw } = this.props;
        const { fixSidebar } = this.state;
        const { opened, abtest } = this.props.application
        return (
            <div className={s.mainSidebar}>
                <div className={fixSidebar ? s.placeholder : ''} />
                <div className={`${s.sidebar} ${fixSidebar ? s.fixed : ''} ${is_staff ? s.staff : ''}`}>
                    <div className={s.mobileHidden}>
                         {is_staff && <a href="/"><img className={s.logo} src={AgilisBlanco} alt={"Logo Agilis blanco"} /></a>}
                        <div className={s.linkList}>
                            {is_staff && !!borrower && borrower.first_name &&
                            <h4>{`${this.props.borrower.first_name} ${this.props.borrower.last_name}: deal`} {opened ? <span style={{color:'green'}}>abierto</span>
                            : <span style={{color:'red'}}>rechazado</span>}</h4>}
                            <Links list={list} next={next} abtestData={abtest} urlLocation={urlLocation} path={path} uw={uw}/>
                        </div>
                        {children}
                    </div>
                    <div className={s.mobile}>
                        <div className={s.burgerLinks}>
                            <Links  list={list} next={next} urlLocation={urlLocation} path={path} closeModal={closeModal} mobile={mobile} uw={uw} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ user, application }) => ({is_staff: !!user.is_staff, borrow:user, application:application.application, borrower:application.borrower });

export default withRouter(connect(mapStateToProps)(Sidebar));
